export default {
    vapid: {
        public:
            'BIZA5ikQ3ZMAPWu1smmdq7Z3HUwTYaoZrG_a-brAbUVQijlKxDS16jtvQ5wmZlrmICuNwcVCed6AUbr_jJNcx9Y',
    },
};
